<template>
  <div id="footer" class="container-fluid">
    <div>
      <div class="right col-xs-6 col-sm-6 col-md-3">
        <div class="first">产品介绍</div>
        <div class="small" @click="sendMessage('/','Service','2')">
          <div>智能换电柜</div>
          <div>智能充电柜</div>
          <div>BMS保护板</div>
          <div>智能充电桩</div>
          <div>更多产品</div>
        </div>
      </div>
      <div class="right col-xs-6 col-sm-6 col-md-3">
        <div class="first">项目开发</div>
        <div class="small">
          <div @click="sendMessage('/software','software','3')">充电桩系统</div>
          <div @click="sendMessage('/software/bigData','bigData','3')">租车系统</div>
          <div @click="sendMessage('/software/Chargingcabinetsystem','Chargingcabinetsystem','3')">充电柜系统</div>
          <div @click="sendMessage('/software/Batteryexchange','Batteryexchange','3')">换电柜系统</div>
        </div>
      </div>
      <div class="right col-xs-12 col-sm-12 col-md-3">
        <div class="first">关于我们</div>
        <div class="small">
          <div  @click="sendMessage('/adboutUs/CompanyIntroduction','CompanyIntroduction','5')">公司简介</div>
          <div @click="sendMessage('/adboutUs/honor','honor','5')">荣誉资质</div>
          <div @click="sendMessage('/adboutUs/aboutsPeixun','aboutsPeixun','5')">培训学员</div>
        </div>
      </div>
      <div class="right col-xs-12 col-sm-12 col-md-3">
        <div class="ContactUs first">联系我们</div>
        <div class="big">
          <div>
            <!-- <div class="ContactText">联系人:屈总</div> -->
            <div class="ContactText">电话:0769-22770169</div>
            <div class="ContactText">邮箱:foxai3144@163.com</div>
            <div class="ContactText">
              地址:广东东莞市中堂镇北王路中堂段239号7栋702室
            </div>
          </div>
          <!-- <div>
            <img src="../assets/kaifaxianmu/code.png" alt="" srcset="" />
          </div> -->
        </div>
      </div>
    </div>

    <div class="record col-xs-12 col-sm-12 col-md-12">
      <div>
        网站备案:粤ICP备2023119960号-2
      </div>
      <div>
        东莞市狐锂智能科技有限公司 版权所有Copyright © 2024 All rights reserved
      </div>
      <div class="bottomIcon">
        <div class="icon"><img src="../assets/kaifaxianmu/beian.png" alt=""></div>
        <div>粤公网安备 粤公网安备44190002007717号号</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods:{
    sendMessage(url,name,index){
      this.$store.commit('updateMessage', index)
      // this.$emit('sendMessage', index);
      this.$router.push({
        name: name,
        url:url,
      })
    }
  },
};
</script>
<style scoped>
@import url("./Footer.css");
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue